<template>
    <div class="sidebar">
        <div class="sidebar-backdrop" @click="close" v-if="isPanelOpen"></div>
        <transition name="slide">
            <div v-if="isPanelOpen" class="sidebar-panel">
                <b-container  v-bind:class="[{ busy: busy }, 'opacity-transition']">
                    <pb-spinner v-if="busy"/>
                    <div class="mb-3" :key="filter.key" v-for="(filter) in localFilterList">
                        <h5>{{ $t(`filter_key_${filter.key}`) }}</h5>
                        <b-row>
                            <b-col :md="filter.key === 'size' ? 4: 12" :key="filterItem.id + index"
                                   v-for="(filterItem, index) in filter.items">
                                <b-button class="filter-btn" block :pressed="filterItem.active"
                                          @click="toggleFilter(filter.key, filterItem)" pill>
                                    {{filterItem.label || $t(`filter_item_label_${filterItem.id}`)}}
                                </b-button>
                            </b-col>

                        </b-row>

                    </div>
                    <div class="mt-5">
                        <b-button block @click="confirm()" variant="primary" class="my-2">SHOW {{count}} RESULTS</b-button>
                        <b-button block @click="reset()" variant="secondary">RESET FILTER</b-button>
                    </div>
                </b-container>
            </div>
        </transition>
    </div>
</template>
<script>

    export default {
        data: function () {
            return {
                isPanelOpen: false,
                neverOutOfStockFilter: false,
                localFilterList: []
            }
        },
        props: {
            currentFilterList: {
                type: Array,
                default: () => []
            },
            category: {
                type: Object
            },
            count: {
                type: Number
            },
            busy: {
                type: Boolean
            }
        },
        computed: {
            queryParamObj: function () {
                let queryParam = {};

                this.localFilterList.forEach(filterItem => {
                    let activeItem = filterItem.items.find(item => item.active);

                    if (activeItem) {
                        queryParam[filterItem.key] = activeItem.value;
                    }
                });

                return queryParam
            }
        },
        methods: {
            toggleFilter(name, value) {
                this.localFilterList.forEach(filterItem => {
                    if (filterItem.key === name) {
                        filterItem.items.forEach(item => {
                            item.active = !item.active ? (value.id === item.id) : false;
                        });
                    }
                });

                this.prefetch();
            },
            prefetch() {
                this.$emit('filteredArticleCount', this.queryParamObj);
            },
            reset() {
                this.localFilterList.forEach(filterItem => {
                    filterItem.items.forEach(item => {
                        item.active = false;
                    });
                });

                this.confirm();
            },
            confirm() {
                this.$router.push({
                    params: {id: this.category.id},
                    query: this.queryParamObj
                })
            },
            open() {
                this.isPanelOpen = true
            },
            close() {
                this.isPanelOpen = false
            }
        },
        watch: {
            currentFilterList: {
                handler: function (val) {
                    this.localFilterList = this.$_.cloneDeep(val);
                },
                deep: true,
                immediate: true
            }
        },
    }
</script>

<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .slide-enter-active,
    .slide-leave-active {
        transition: transform 0.2s ease;
    }

    .slide-enter,
    .slide-leave-to {
        transform: translateX(100%);
        transition: all 150ms ease-in 0s
    }


    .sidebar-backdrop {
        background-color: rgba(0, 0, 0, .5);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        cursor: pointer;
        z-index: 1000;

    }

    .sidebar-panel {
        overflow-y: auto;
        background-color: white;
        position: fixed;
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.5);
        right: 0;
        top: 0;
        height: 100vh;
        z-index: 1001;
        padding: 3rem 20px 2rem 20px;
        width: 415px;
        .filter-btn {
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
        }
        h5 {
            height: 38px;
            color: #4A4B4D;
            font-family: $font-robo;;
            font-size: 13px;
            font-weight: 300;
            letter-spacing: 0.97px;
            line-height: 26px;
            text-align: center;
        }
    }

</style>